    /* share block pdp start */
    document.querySelectorAll('.product-block.rfr-share, .product-block.rfr-share-tp').forEach(function (el) {
      el.addEventListener('click', function () {
        var popup = document.querySelector('.product-block.rfr-share .popuptext');
        if (popup && popup.classList.contains('show-social')) {
          document.body.classList.add('opnsoc');
        } else {
          document.body.classList.remove('opnsoc');
        }
      });
    });
    /* share block pdp end */

    /* offer block pdp */
    document.querySelectorAll('.ofr-tw .ofr-cpn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.add('copied');
        var textEl = btn.querySelector('.ofr-txt');
        var text = textEl ? textEl.textContent : '';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text);
        }
        setTimeout(function () {
          document.querySelectorAll('.ofr-tw .ofr-cpn').forEach(function (el) { el.classList.remove('copied'); });
        }, 800);
      });
    });
    /* size guide block pdp start */
    document.querySelectorAll('.page-content--product [data-open-size-chart-popup]').forEach(function (btn) {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        document.body.classList.add('size-chart-show');
        var popup = document.querySelector('#MainContent .halo-size-chart-popup');
        if (popup) popup.classList.add('is-show');
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-close-size-chart-popup]')) {
        document.body.classList.remove('size-chart-show');
        document.querySelectorAll('.halo-size-chart-popup').forEach(function (el) { el.classList.remove('is-show'); });
      }
    });

    document.addEventListener('click', (event) => {
        if (document.body.classList.contains('size-chart-show')) {
            if (
                !event.target.closest('[data-open-size-chart-popup]') &&
                !event.target.closest('[data-size-chart-popup]')
            ) {
                document.body.classList.remove('size-chart-show');
            }
        }
    });
    /* size guide block pdp end */
    /* recently viewed script pdp start */
    const isProductTemplate = document.body.classList.contains('template-product');
    const recentlyViewedSection = document.querySelector('[data-rfr-visibility-hydrate="recently-viewed"]');
    const recentlyViewedContainer = document.getElementById('recently-viewed-products');
    const RECENTLY_VIEWED_LIMIT = 8;
    const recentlyViewedProductRequests = new Map();
    let reviewHydrationRaf = null;

    function hydrateReviewBadges(scope) {
      if (!scope || !window.jdgm || typeof window.jdgm.refreshAllWidgets !== 'function') {
        return;
      }

      if (reviewHydrationRaf) {
        cancelAnimationFrame(reviewHydrationRaf);
      }

      reviewHydrationRaf = requestAnimationFrame(() => {
        try {
          window.jdgm.refreshAllWidgets();
        } catch (e) {}
        reviewHydrationRaf = null;
      });
    }

    function parseRecentlyViewedData() {
      try {
        const raw = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
        if (!Array.isArray(raw)) return [];
        return raw;
      } catch (e) {
        return [];
      }
    }

    function getRecentlyViewedProduct(handle) {
      if (!handle) return Promise.resolve(null);

      if (recentlyViewedProductRequests.has(handle)) {
        return recentlyViewedProductRequests.get(handle);
      }

      const request = fetch(`/products/${handle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        });

      recentlyViewedProductRequests.set(handle, request);
      return request;
    }

    function loadRecentlyViewedProducts() {
      if (!isProductTemplate || !recentlyViewedContainer) return;
      if (recentlyViewedContainer.dataset.rfrLoaded === '1') return;

      const recentlyViewedData = parseRecentlyViewedData();
      if (!recentlyViewedData.length) {
        const retryCount = Number(recentlyViewedContainer.dataset.rfrRetryCount || 0);

        if (retryCount < 4) {
          recentlyViewedContainer.dataset.rfrRetryCount = String(retryCount + 1);
          delete recentlyViewedContainer.dataset.rfrScheduled;

          setTimeout(() => {
            scheduleRecentlyViewedLoad();
          }, 500 * (retryCount + 1));
        }

        return;
      }

      recentlyViewedContainer.dataset.rfrLoaded = '1';
      if (recentlyViewedSection) {
        recentlyViewedSection.classList.add('rfr-is-loading');
      }

      const uniqueProducts = [];
      const seenHandles = new Set();

      for (let i = 0; i < recentlyViewedData.length; i++) {
        const product = recentlyViewedData[i];
        if (!product || !product.handle || seenHandles.has(product.handle)) continue;

        seenHandles.add(product.handle);
        uniqueProducts.push(product);

        if (uniqueProducts.length >= RECENTLY_VIEWED_LIMIT) {
          break;
        }
      }

      if (!uniqueProducts.length) {
        if (recentlyViewedSection) {
          recentlyViewedSection.classList.add('hide');
          recentlyViewedSection.classList.remove('rfr-is-loading');
        }
        return;
      }

      const productRequests = uniqueProducts.map(product => {
        let productHandle = product.handle;
        let productReviewMetafields = product.metafield;

        return getRecentlyViewedProduct(productHandle)
          .then(responseProduct => {
            if (!responseProduct) return null;

            let reguPrice = responseProduct.price;
            let comparePrice = responseProduct.compare_at_price;

            let actualPrice = (reguPrice / 100);
            actualPrice = actualPrice.toLocaleString(window.Shopify.locale, { style: 'currency', currency: Shopify.currency.active, minimumFractionDigits: 0, maximumFractionDigits: 0 });
            let salePrice = (comparePrice / 100);
            salePrice = salePrice.toLocaleString(window.Shopify.locale, { style: 'currency', currency: Shopify.currency.active, minimumFractionDigits: 0, maximumFractionDigits: 0 });

            // Calculate percentage off
            let percentageOff = ((comparePrice - reguPrice) * 100) / comparePrice;
            percentageOff = Math.round(percentageOff);
            let productAvailable = responseProduct.available;
            let checkProductHandle = responseProduct.handle;
            let formBtnHTML = ``;
            let parentClassWrapper = 'pro-avail';

            if (checkProductHandle.includes("with-personalized")) {
              formBtnHTML = `<div>
                            <a href="${checkProductHandle}"><button type="button" name="add" class="button button-ATC is-visible">Customization</button></a>
                          </div>`;
            } else {
              if(productAvailable) {
                formBtnHTML = `<div>
                            <button type="submit" name="add" class="button button-ATC is-visible" data-btn-addToCart>Add to Cart</button>
                          </div>`;
              } else {
                formBtnHTML = `<div>
                            <button name="sold-out" class="button button-ATC is-visible 1234" data-btn-addToCart tabindex="0" disabled>Sold Out</button>
                          </div>`;
                parentClassWrapper = 'pro-notavail';
              }
            }

            let priceHTML = ``;

            if (reguPrice > comparePrice) {
              priceHTML = `
                  <div class="price__regular">
                      <dd class="price__last">
                        <span class="price-item price-item--regular">${actualPrice}</span>
                      </dd>
                  </div>
                `;
            } else {
              priceHTML = `
                <div class="price__sale">
                  <dd class="price__last">
                    <span class="price-item price-item--sale">${actualPrice}</span>
                  </dd>
                  <dd class="price__compare">
                    <span class="price-item price-item--regular">${salePrice}</span>
                  </dd>
                  <div class="desc-per">
                   <dd class="price-item">${percentageOff}%</dd>
                 </div>
                </div>
              `;
            }

            let productHTML = `
                <li>
                  <div class="product-item">
                    <div class="card">
                      <div class="card-product">
                        <div class="card-product__wrapper">
                          <a class="card-link" href="${product.url || responseProduct.url}" title="${responseProduct.title}">
                            <img src="${product.variant_image || responseProduct.images[0]}" alt="${responseProduct.title}" class="motion-reduce">
                          </a>
                        </div>
                      </div>
                      <div class="card-information">
                        <div class="card-information__wrapper text-">
                          <a
                            class="card-title link-underline card-title-ellipsis"
                            href="${product.url || responseProduct.url}"
                            data-product-title="${responseProduct.title}"
                            data-product-url="${product.url || responseProduct.url}"
                          >
                            <span class="text">
                              ${responseProduct.title}
                            </span>
                          </a>
                          <div class="review-wrap">
                            <div class='jdgm-widget jdgm-preview-badge' data-id='${responseProduct.id}' data-template='manual-installation' data-auto-install='false'>
                              ${productReviewMetafields}
                            </div>
                          </div>
                          <div class="card-price">
                            <div class="price  price--on-sale">
                              <dl>
                                ${priceHTML}
                              </dl>
                            </div>`;

            if (reguPrice > 0) {
              productHTML = productHTML + `<div class="card-action rb-demo ${parentClassWrapper}">
                              <form class="variants  rb-varient add-to-cart-form" action="/cart/add" method="post" id="product-form-${responseProduct.id}" data-product-id="${responseProduct.id}">
                                <input type="hidden" name="id" value="${product.variant_id || responseProduct.variants[0].id}">
                                <input type="hidden" name="quantity" value="1" tabindex="-1">
                                ${formBtnHTML}
                              </form>`;
            }

            productHTML = productHTML + `</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
            `;

            recentlyViewedContainer.insertAdjacentHTML('beforeend', productHTML);
            hydrateReviewBadges(recentlyViewedContainer);
            return responseProduct;
          })
          .catch(() => {});
      });

      Promise.allSettled(productRequests).finally(() => {
        if (recentlyViewedSection) {
          recentlyViewedSection.classList.remove('rfr-is-loading');
        }
      });
    }

    function scheduleRecentlyViewedLoad() {
      if (!isProductTemplate || !recentlyViewedContainer) return;
      if (recentlyViewedContainer.dataset.rfrScheduled === '1') return;

      recentlyViewedContainer.dataset.rfrScheduled = '1';

      const startLoad = () => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => loadRecentlyViewedProducts(), { timeout: 2000 });
          return;
        }

        setTimeout(() => loadRecentlyViewedProducts(), 1);
      };

      startLoad();
    }

    if (isProductTemplate && recentlyViewedContainer) {
      const scheduleRecentlyViewedOnFirstScrollFallback = () => {
        const onUserScrollIntent = () => {
          window.removeEventListener('scroll', onUserScrollIntent);
          window.removeEventListener('wheel', onUserScrollIntent);
          window.removeEventListener('touchmove', onUserScrollIntent);

          // Fallback for collapsed/hidden layouts where intersection callbacks never fire.
          scheduleRecentlyViewedLoad();
        };

        window.addEventListener('scroll', onUserScrollIntent, { once: true, passive: true });
        window.addEventListener('wheel', onUserScrollIntent, { once: true, passive: true });
        window.addEventListener('touchmove', onUserScrollIntent, { once: true, passive: true });
      };

      scheduleRecentlyViewedOnFirstScrollFallback();

      if ('IntersectionObserver' in window) {
        const recentlyViewedTarget = recentlyViewedSection || recentlyViewedContainer;
        const recentlyViewedObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            scheduleRecentlyViewedLoad();
          });
        }, { rootMargin: '0px 0px' });

        recentlyViewedObserver.observe(recentlyViewedTarget);
      } else {
        scheduleRecentlyViewedLoad();
      }
    }
    // Function to initialize Slick slider
    // function initializeSlick() {
    //   $(".recently-pro-carousel").slick({
    //     mobileFirst: true,
    //     adaptiveHeight: true,
    //     vertical: false,
    //     infinite: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     dots: false,
    //     responsive: [
    //       {
    //         breakpoint: 1599,
    //         settings: {
    //           arrows: true,
    //           dots: false,
    //           slidesToShow: 5,
    //           slidesToScroll: 2,
    //         },
    //       },
    //       {
    //         breakpoint: 1024,
    //         settings: {
    //           arrows: true,
    //           dots: false,
    //           slidesToShow: 5,
    //           slidesToScroll: 2,
    //         },
    //       },
    //       {
    //         breakpoint: 991,
    //         settings: {
    //           arrows: true,
    //           dots: false,
    //           slidesToShow: 4,
    //           slidesToScroll: 2,
    //         },
    //       },
    //       {
    //         breakpoint: 767,
    //         settings: {
    //           arrows: true,
    //           dots: false,
    //           slidesToShow: 3,
    //           slidesToScroll: 2,
    //         },
    //       },
    //       {
    //         breakpoint: 320,
    //         settings: {
    //           arrows: true,
    //           dots: false,
    //           slidesToShow: 2,
    //           slidesToScroll: 2,
    //         },
    //       },
    //     ],
    //   });
    // }
    /* recently viewed script pdp end */
window.onload = function() {
    /* get review number pdp */
    const reviewSpan = document.querySelector('.pdp-review .re');
    if (reviewSpan) {
      const reviewMatch = reviewSpan.textContent.match(/\d+/);
      if (reviewMatch) {
        reviewSpan.textContent = reviewMatch[0];
      }
    }

    // setTimeout(function () {
    //   let referenceElement = document.querySelector('.evm_wiser_heading');
    //   let newParagraph = document.createElement('div');
    //   newParagraph.classList.add("rfe-subttl");
    //   newParagraph.innerHTML = 'Buy all 3 &amp; get an <span>extra 5% off</span>';
    //   if (referenceElement) {
    //     referenceElement.insertAdjacentElement('afterend', newParagraph);
    //   }
    // }, 1000);

    // Run only on product page
    if (document.body.classList.contains('template-product')) {
      function insertOfferMessage() {
        const referenceElement = document.querySelector('.evm_wiser_heading');
        if (referenceElement && !document.querySelector('.rfe-subttl')) {
          const newParagraph = document.createElement('div');
          newParagraph.classList.add("rfe-subttl");
          newParagraph.innerHTML = 'Buy all 3 &amp; get an <span>extra 5% off</span>';
          referenceElement.insertAdjacentElement('afterend', newParagraph);
          return true;
        }
        return !!document.querySelector('.rfe-subttl');
      }

      if (!insertOfferMessage()) {
        if ('MutationObserver' in window) {
          const offerObserver = new MutationObserver(() => {
            if (insertOfferMessage()) {
              offerObserver.disconnect();
            }
          });

          offerObserver.observe(document.body, { childList: true, subtree: true });
          setTimeout(() => offerObserver.disconnect(), 5000);
        } else {
          setTimeout(insertOfferMessage, 700);
        }
      }
    }
    
};
document.addEventListener("DOMContentLoaded", function () {
    /* customize product atc disabled popup */
    setTimeout(function () {
      let findPtcBtn = document.querySelector('.ptc_button');
      let cartPaymentBtn = document.querySelector('[data-add-to-cart]');
      if(findPtcBtn) {
        if (cartPaymentBtn && cartPaymentBtn.hasAttribute('disabled')) {
          findPtcBtn.classList.add('disabled');
          findPtcBtn.disabled = true;
          findPtcBtn.textContent = cartPaymentBtn.textContent;
        }
        document.querySelector(".ptc_button").addEventListener("click", function () {
            setTimeout(function () {
                const popup = document.querySelector(".pplr_crop-modal");
                if (popup) {
                    const addToCartButton = popup.querySelector(".p_a_t_c");
                    const inputFields = popup.querySelectorAll("textarea, input[type='text'], input[type='number']");
                    addToCartButton.disabled = true;
                    addToCartButton.classList.add("disabled");
                    inputFields.forEach((field) => {
                        field.addEventListener("input", function () {
                            let allFilled = Array.from(inputFields).some((input) => input.value.trim() !== "");
                            addToCartButton.disabled = !allFilled;
                            if (allFilled) {
                                addToCartButton.classList.remove("disabled");
                            }else{
                                addToCartButton.classList.add("disabled");
                            }
                        });
                    });
                }
            }, 1000);
        });
      }
    }, 1000);
});
(function() {

  const originalFetch = window.fetch;

  window.fetch = function(input, init) {

    let requestUrl = '';

    if (typeof input === 'string') {
      requestUrl = input;
    } else if (input && input.url) {
      requestUrl = input.url;
    }

    if (!requestUrl || requestUrl.indexOf('/cart/') === -1) {
      return originalFetch.apply(this, arguments);
    }

    return originalFetch.apply(this, arguments).then(response => {

      /* ==========================
         HANDLE PRODUCT ADD
      ========================== */
      if (requestUrl.includes('/cart/add')) {

        response.clone().json().then(addedItem => {

          const installVariantId = addedItem.properties?._installation_variant_id;
          if (!installVariantId) return;

          // Prevent infinite loop
          if (addedItem.properties && addedItem.properties._linked_to) return;

          // 🔥 CHECK CHECKBOX STATE HERE
          const checkbox = document.querySelector('#installation-checkbox');
          if (!checkbox || !checkbox.checked) return;

          originalFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: installVariantId,
              quantity: addedItem.quantity,
              properties: {
                _linked_to: addedItem.key
              }
            })
          }).then(() => {
            refreshCartDrawer();
          });

        }).catch(() => {});
      }

      /* ==========================
         HANDLE REMOVE / QTY CHANGE
      ========================== */
      // Attribute/note-only writes (apps such as wiserai, GST note) change no lines, so skip the cart re-check.
      const body = init && typeof init.body === 'string' ? init.body : '';
      const writesOnlyAttributes = /"(attributes|note)"/.test(body) && !/"(updates|discount|items)"/.test(body);

      if ((requestUrl.includes('/cart/change') || requestUrl.includes('/cart/update')) && !writesOnlyAttributes) {

        setTimeout(() => {
          removeOrphanInstallations();
        }, 300);

      }

      return response;
    });

  };


  function removeOrphanInstallations() {

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        cart.items.forEach(item => {

          if (item.properties && item.properties._linked_to) {

            const parentExists = cart.items.find(
              parent => parent.key === item.properties._linked_to
            );

            if (!parentExists) {

              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0
                })
              }).then(() => {
                refreshCartDrawer();
              });

            }
          }
        });
      });
  }


  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

})();
